// extracted by mini-css-extract-plugin
module.exports = {"info":"PurchaseEditForm_info__1_gxV","inputStyle":"PurchaseEditForm_inputStyle__3-vnq"};